import { useEffect, useState } from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";
// import { Link } from "react-router-dom";
import { useNavigate, useParams } from "react-router-dom";
import { useAddStocksMutation, useUpdateStockMutation, useGetStockbyIdQuery, useStoreProductTypeMutation } from "../../Services/StockManagemntAPI"
import VariantProduct from "./variantProduct"
import { useGetProductByIdQuery } from "../../Services/ProductAPI";

function AddStock() {
    const navigate = useNavigate();
    const { id } = useParams();
    const [stock, setStock] = useState("");
    const [sku, setSku] = useState("");

    const [errors, setErrors] = useState({});
    const [apiError, setApiError] = useState(null);
    const [productType, setProductType] = useState(false);
    // Update brands API call setup
    const [updateStock, { isLoading: updateLoading }] = useUpdateStockMutation();
    const [AddStock, { isLoading: addLoading }] = useAddStocksMutation();
    const { data: stockDetail, isLoading: loadingContent, error, refetch: refetchStockDetail } = useGetStockbyIdQuery(id);
    const { data: productDetail } = useGetProductByIdQuery(id);
    const isVarient =  productDetail?.data?.is_variant;

    useEffect(()=>{
        setProductType(isVarient);
    }, [isVarient])
    const [StoreProductType] = useStoreProductTypeMutation();
    useEffect(() => {
        refetchStockDetail();
    }, [refetchStockDetail])

    useEffect(() => {
        setStock(stockDetail?.variant_combinations?.[0]?.stock || "");
        setSku(stockDetail?.variant_combinations?.[0]?.sku || "")
    }, [stockDetail])

    const validateForm = () => {
        let newErrors = {};
        if (!stock || isNaN(stock)) newErrors.stock = "Stock should be a valid number";
        if (!sku.trim()) newErrors.sku = "SKU is required";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
    
        // validate form
        if (!validateForm()) return;
    
        // Check if variant_combinations is empty
        const isVariantCombinationsEmpty = stockDetail?.variant_combinations?.length === 0;
    
        try {
            // Store Product Type
            let productTypeData = {
                product_id: id,
                is_variant: productType
            };
            await StoreProductType(productTypeData).unwrap();
    
            // Handle Stock Update or Addition
            if (isVariantCombinationsEmpty) {
                let formData = {
                    stock: stock,
                    sku: sku
                };
    
                await AddStock({ formData, id }).unwrap();
                alert("Stock added successfully!");
            } else {
                const varientId = stockDetail?.variant_combinations?.[0].id;
                let formData = {
                    id: varientId,
                    stock: stock,
                    sku: sku
                };
    
                await updateStock({ formData, id }).unwrap();
                alert("Stock updated successfully!");
            }
    
            // Reset states
            setStock("");
            setSku("");
            setErrors({});
            setApiError(null);
            navigate("/products");
    
        } catch (error) {
            setApiError(error.data?.message || "Something went wrong");
        }
    };
    
    const handleChangeProducttype = async (e) => {
        setProductType(e.target.value);
    }
    if (loadingContent) return <div class="loader"></div>;
    if (error) return <p>Failed to load Data</p>;

    return (
        <div>
            {/* <h3>Manage Stock</h3> */}
            {/* <div className="breadcrum mb-4">
                <p>
                    <FontAwesomeIcon icon={faAngleLeft} className="mx-2" />
                    <Link to="/products"><span>Back</span></Link>
                </p>
            </div> */}
            <div >
                <div className="row">
                    {/* Stock Field */}
                    <label>Select Product Type</label>
                    <div className="col-md-6 col-sm-12 col-lg-6">
                        <select onChange={handleChangeProducttype} className="form-control mb-4" value={productType}>
                            <option value="">Select</option>
                            <option value="0">Simple Product</option>
                            <option value="1">Variant Product</option>
                        </select>
                    </div>
                </div>
                {(productType === "0" || productType === 0) &&
                    <div>
                        <form onSubmit={handleSubmit}>
                            <div className="row">
                                {/* Stock Field */}
                                <div className="col-md-6 col-sm-12 col-lg-6">
                                    <div className="mb-4 text-start">
                                        <label htmlFor="stock" className="form-label">Stock</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            id="stock"
                                            placeholder="Enter Stock"
                                            value={stock}
                                            onChange={(e) => setStock(e.target.value)}
                                            onFocus={() => setErrors((prevErrors) => ({ ...prevErrors, stock: "" }))}
                                        />
                                        {errors.stock && <p className="text-danger">{errors.stock}</p>}
                                    </div>
                                </div>

                                {/* SKU Field */}
                                <div className="col-md-6 col-sm-12 col-lg-6">
                                    <div className="mb-4 text-start">
                                        <label htmlFor="sku" className="form-label">SKU</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="sku"
                                            placeholder="Enter SKU"
                                            value={sku}
                                            onChange={(e) => setSku(e.target.value)}
                                            onFocus={() => setErrors((prevErrors) => ({ ...prevErrors, sku: "" }))}
                                        />
                                        {errors.sku && <p className="text-danger">{errors.sku}</p>}
                                    </div>
                                </div>
                            </div>

                            {/* API Error Message */}
                            {apiError && <p className="text-danger text-center">{apiError}</p>}

                            {/* Submit Button */}
                            <button type="submit" className="btn btn-primary" disabled={addLoading || updateLoading}>
                                {addLoading || updateLoading ? "Submitting..." : "Submit"}
                            </button>

                        </form>
                    </div>}
                {(productType === "1" || productType === 1) && <VariantProduct productType={productType}/>}

            </div>

        </div>
    );
}

export default AddStock;
